import { useLocation, useNavigate } from "react-router-dom";
import { wasOpenedInAppTab } from "../utils/tabNavigation";

export default function useSmartBack(fallbackPath) {
  const navigate = useNavigate();
  const location = useLocation();

  // Where to go when the tab has no history to go back through. The caller can
  // pass it in router state (<Link state={{ returnTo }}>); it never appears in
  // the URL. Only same-app paths are accepted.
  const returnTo = location.state?.returnTo;
  const safeReturnTo =
    typeof returnTo === "string" &&
    returnTo.startsWith("/") &&
    !returnTo.startsWith("//")
      ? returnTo
      : fallbackPath;

  return () => {
    if (wasOpenedInAppTab()) {
      window.close();
      return;
    }

    const historyIndex = window.history.state?.idx;
    const hasHistory =
      typeof historyIndex === "number"
        ? historyIndex > 0
        : window.history.length > 1;

    if (hasHistory) {
      navigate(-1);
      return;
    }

    navigate(safeReturnTo);
  };
}
